@if (inProgress | async) {
  <section class="container-spinner" mode="indeterminate">
    <div class="spinner-border" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </section>
}
